import React, { useRef, useEffect, useState } from 'react';
import { TextBox } from 'devextreme-react';
import dxValidator from 'devextreme/ui/validator';

const SixDigitInput = ({ onValueChange, initialValue = '', numberOfDigits = 5, onBtnSendCodeSMS }) => {
    const [value, setValue] = useState(initialValue);
    const textBoxRef = useRef(null);
    const validatorRef = useRef(null);

    useEffect(() => {
        if (textBoxRef.current && textBoxRef.current.instance) {
            validatorRef.current = new dxValidator(textBoxRef.current.instance.element(), {
                validationRules: [
                    {
                        type: 'required',
                        message: 'Поле обязательно'
                    },
                    {
                        type: 'pattern',
                        pattern: new RegExp(`^\\d{${numberOfDigits}}$`),
                        message: `Введите ровно ${numberOfDigits} цифр`
                    }
                ]
            });
        }

        return () => {
            if (validatorRef.current) {
                validatorRef.current.dispose();
            }
        };
    }, [numberOfDigits]);

    const validate = () => {
        if (validatorRef.current) {
            return validatorRef.current.validate();
        }
        return { isValid: false };
    };

    const handleValueChange = (e) => {
        const newValue = e.value.replace(/\D/g, '').slice(0, numberOfDigits);
        setValue(newValue);
        const validationResult = validate();
        // Передаем значение и результат валидации в родительский компонент
        if (onValueChange) {
            onValueChange(newValue, validationResult.isValid);
        }
    };

    return (
        <TextBox
            ref={textBoxRef}
            value={value}
            onValueChanged={handleValueChange}
            valueChangeEvent="keyup"
            onInput={(e) => {
                const onlyNumbers = e.event.target.value.replace(/\D/g, '').slice(0, numberOfDigits);
                e.event.target.value = onlyNumbers;
            }}
            placeholder={(0).toString().padStart(numberOfDigits, '0')}
            showClearButton={true}
            onEnterKey={onBtnSendCodeSMS}
        />
    );
};

export default SixDigitInput;
